import { Button } from '@/common/ui/button'
import { parseAsString, useQueryState } from 'nuqs'
import { useDate } from '@/common/hooks/useDate'
import { format, subMonths } from 'date-fns'
import * as React from 'react'
import { useState } from 'react'

const monthOptions = [
	{
		label: 'เดือนนี้',
		value: 'thisMonth',
	},
	{
		label: 'เดือนที่แล้ว',
		value: 'lastMonth',
	},
]

export default function MonthRangeButtons() {
	const { setDate } = useDate()
	const [activeMonth, setActiveMonth] = useQueryState(
		'activeMonth',
		parseAsString.withDefault('thisMonth'),
	)

	const [lastMothCount, setLastMothCount] = useState(0)

	const handleMonthChange = (value: string) => {
		setActiveMonth(value)
		const today = new Date()

		switch (value) {
			case 'thisMonth': {
				const newDate = new Date(today.getFullYear(), today.getMonth(), 1)
				const formattedDate = format(newDate, 'yyyy-MM-dd')
				setDate(formattedDate)
				setLastMothCount(0)
				break
			}
			case 'lastMonth': {
				const lastMonth = subMonths(today, 1 + lastMothCount)
				const newDate = new Date(
					lastMonth.getFullYear(),
					lastMonth.getMonth(),
					1,
				)
				const formattedDate = format(newDate, 'yyyy-MM-dd')
				setDate(formattedDate)
				setLastMothCount((prev) => prev + 1)
				break
			}
			default: {
				setActiveMonth('')
			}
		}
	}

	React.useEffect(() => {
		// If no active month is set (first load), trigger thisMonth
		if (!activeMonth) {
			handleMonthChange('thisMonth')
		} else {
			// If there's an active month from URL, trigger its handler
			handleMonthChange(activeMonth)
		}
	}, []) // Empty dependency array means this runs once on mount

	return (
		<div className="flex flex-wrap gap-2">
			{monthOptions.map((option) => (
				<Button
					key={option.value}
					variant={activeMonth === option.value ? 'default' : 'outline'}
					size="sm"
					onClick={() => handleMonthChange(option.value)}
				>
					{option.label}{' '}
					{option.value === 'lastMonth' ? `(${lastMothCount})` : null}
				</Button>
			))}
		</div>
	)
}
